import * as React from 'react';
import {Stack, Chip, CardContent, Card, Grid} from '@mui/material';
import Typography from '@mui/material/Typography';

import IconButton from "@mui/material/IconButton";
import {PeopleOutlineOutlined, MoreVertOutlined} from '@mui/icons-material';
import {barElementClasses, BarPlot} from "@mui/x-charts/BarChart";
import {ChartContainer} from "@mui/x-charts";
import {sumBy} from "lodash";
import {XYVO} from "@/service/analyze";
import {ChartsLoadingOverlay} from "@mui/x-charts/ChartsOverlay";
import {lineElementClasses} from "@mui/x-charts/LineChart";

export interface ProjectCardProps {
    projects?: XYVO[]
    loading: boolean
}

export default function ProjectCard({projects, loading}: ProjectCardProps) {
    return (
        <Card variant="outlined" sx={{height: '100%', flexGrow: 1, backgroundColor: '#ffe4ec'}}>
            <CardContent sx={{height: '100%'}}>
                <Stack justifyContent={'space-between'} height={'inherit'}>
                    <Stack justifyContent={'space-between'} direction={'row'} alignContent={'center'} alignItems={'center'}>
                        <Stack direction="row" spacing={1} alignContent={'center'} alignItems={'center'}>
                            <IconButton sx={{bgcolor: '#ff6692', padding: '4px 12px', borderRadius: '99999px'}}>
                                <PeopleOutlineOutlined sx={{color: '#fff'}}/>
                            </IconButton>
                            <Typography fontWeight={500} component="h1" color={'#7b8893'} variant='body1'>
                                项目
                            </Typography>
                        </Stack>
                        <MoreVertOutlined color={'action'}/>
                    </Stack>
                    <Grid container rowSpacing={6} alignItems={'end'}>
                        <Grid size={5}>
                            <Chip label={<Typography fontSize={'12px'} color={'textSecondary'}>全部</Typography>}/>
                            <Typography component={'h1'} variant={'subtitle1'} fontSize={20} fontWeight={550}>{sumBy(projects, item => item.y) || 0}个</Typography>
                        </Grid>
                        <Grid size={7}>
                            <ChartContainer
                                height={100}
                                localeText={{loading: loading ? "加载中" : ""}}
                                yAxis={[{position: 'none',}]}
                                margin={{left: 0, right: 0, top: 0, bottom: 0}}
                                series={[{data: projects?.map(item => item.y) || [], type: 'bar', stack: 'total', color: '#ff6692'},
                                    {
                                        data: projects?.map(item => item.y) || [],
                                        type: 'bar',
                                        stack: 'total',
                                        color: '#e7d0d9',
                                    }]}
                                xAxis={[{
                                    categoryGapRatio: 0.4,
                                    scaleType: 'band', data: projects?.map(item => item.x) || []
                                },] as any}
                            >
                                <ChartsLoadingOverlay/>
                                <BarPlot slotProps={{bar: {rx: 4, ry: 4,}}}/>
                            </ChartContainer>
                        </Grid>
                    </Grid>
                </Stack>
            </CardContent>
        </Card>
    );
}
